import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faTimes } from "@fortawesome/free-solid-svg-icons";

import NoteDisplay from "./components/notes-display";

import "./notes.scss";

function getWindowBox() {
    return {
        left: 0,
        right: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
        top: 0,
        bottom: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
    };
}

var target = null;

const NotePopOut = (props) => {
    const popoutRef = useRef();

    useEffect(() => {
        let resizeObserverValue = popoutRef.current;
        setInitialPos();

        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("mousemove", onMouseMove);
        window.addEventListener("resize", handleResize);
        resizeObserver.observe(resizeObserverValue);

        return () => {
            resizeObserver.unobserve(resizeObserverValue);
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const setInitialPos = () => {
        var wRect = getWindowBox();
        var tgtRect = popoutRef.current.getBoundingClientRect();
        var scrollBarWidth = window.innerWidth - document.body.clientWidth;
        const translateX = wRect.right - tgtRect.width - scrollBarWidth - 20 + "px";
        const translateY = wRect.bottom - tgtRect.height - 20 + "px";
        Object.assign(popoutRef.current.style, { transform: `translateX(${translateX}) translateY(${translateY})` });
    };

    const handleResize = (e) => {
        if (!popoutRef || !popoutRef.current) {
            return;
        }

        var wRect = getWindowBox();
        var tgtRect = popoutRef.current.getBoundingClientRect();
        var scrollBarWidth = window.innerWidth - document.body.clientWidth;

        var translateX = tgtRect.left + "px";
        var translateY = tgtRect.top + "px";

        if (tgtRect.left + tgtRect.width > wRect.right) {
            translateX = wRect.right - tgtRect.width - scrollBarWidth - 20 + "px";
        }

        if (tgtRect.top + tgtRect.height > wRect.bottom) {
            translateY = wRect.bottom - tgtRect.height - 20 + "px";
        }

        Object.assign(popoutRef.current.style, { transform: `translateX(${translateX}) translateY(${translateY})` });
    };

    const onMouseDown = (e) => {
        // only left mouse button
        if (e.button !== 0) {
            return;
        }

        target = popoutRef.current;
        e.stopPropagation();
        e.preventDefault();
    };

    const onMouseUp = (e) => {
        target = null;

        e.stopPropagation();
        e.preventDefault();
    };
    const onMouseMove = (e) => {
        if (!target) {
            return;
        }

        const offset = {
            x: 15,
            y: 15,
        };

        var translateX = e.clientX - offset.x + "px";
        var translateY = e.clientY - offset.y + "px";
        var wRect = getWindowBox();
        var tgtRect = target.getBoundingClientRect();
        var scrollBarWidth = window.innerWidth - document.body.clientWidth;

        if (e.clientX <= 0) {
            translateX = 0;
        }

        if (e.clientY <= 0) {
            translateY = 0;
        }

        if (e.clientX > wRect.right - tgtRect.width) {
            translateX = wRect.right - tgtRect.width - scrollBarWidth + "px";
        }

        if (e.clientY > wRect.bottom - tgtRect.height) {
            translateY = wRect.bottom - tgtRect.height + "px";
        }

        Object.assign(target.style, { transform: `translateX(${translateX}) translateY(${translateY})` });
    };

    const resizeObserver = new ResizeObserver(handleResize);

    return (
        <div ref={popoutRef} className="popout draggable">
            <div className="popout-controls">
                <div className="button-drag" onMouseDown={onMouseDown}>
                    <FontAwesomeIcon icon={faGripVertical} />
                </div>
                {props.upc && <h2>{props.upc}</h2>}
                <div
                    className="button-close"
                    onClick={() => {
                        props.toggleNotes(false);
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </div>
            </div>
            <NoteDisplay settings={props.settings} taskType={props.taskType} isReadOnly={props.isReadOnly} />
        </div>
    );
};

export default NotePopOut;
